import {ContractorFilter} from "@/dto/payroll/Filters";
import axios, {AxiosResponse} from "axios";
import Pageable from "@/dto/Pageable";
import {IContractor} from "@/components/payroll/business/employments/contractors/Contractor";
import QueryUtils from "@/utils/QueryUtils";
import {GENERAL_FOREIGN_CONTRACTOR_SERVICE} from "@/constants/endpoints";
import authHeader from "@/services/auth-header";
import RegisterContractorPayload from "@/components/payroll/business/employments/contractors/RegisterContractorPayload";
import {IForeignContractor} from "@/components/payroll/business/employments/foreignContractors/ForeignContractorPayloads";

class ForeignContractorService {
    public getAllByFilter(filter: ContractorFilter): Promise<AxiosResponse<Pageable<IContractor>>> {
        const queryString = QueryUtils.buildQueryString(
            ["name", filter.name],
            ["employerId", filter.employerId],
            ["contractorType", filter.contractorType],
            ["pageNumber", filter.pageNumber],
            ["pageSize", filter.pageSize],
            ["orderField", filter.orderField],
            ["orderDirection", filter.orderDirection]
        );
        return axios.get<Pageable<IForeignContractor>>(`${GENERAL_FOREIGN_CONTRACTOR_SERVICE}${queryString}`, {headers: authHeader()})
    }

    public registerContractor(payload: RegisterContractorPayload): Promise<AxiosResponse<void>> {
        return axios.post<void>(`${GENERAL_FOREIGN_CONTRACTOR_SERVICE}`, payload, {headers: authHeader()})
    }
}

export default new ForeignContractorService()